<template>
  <div>
    <div class="bg pic-full"></div>
    <!-- <warn class="warn" :home-lang="home"></warn> -->
    <div class="home">
      <header>
        <head-nav-bar class="head-nav-bar" :home-lang="home"></head-nav-bar>
        <head-nav-bar-mini class="head-nav-bar-mini" :home-lang="home"></head-nav-bar-mini>
      </header>
      <main>
        <introduction class="introduction" :home-lang="home"></introduction>
        <section1 class="section1" :home-lang="home"></section1>
        <section2 class="section2" :home-lang="home"></section2>
        <section3 class="section3" :home-lang="home"></section3>
        <end class="end" :home-lang="home"></end>
      </main>
      <footer>
        <foot-content class="foot-content" :home-lang="home"></foot-content>
      </footer>
    </div>
  </div>
</template>

<script>

import home from "@/lang/zh/home";
import Warn from "@/components/contents/warn";
import HeadNavBar from "@/components/Layouts/HeadNavBar";
import Introduction from "@/components/contents/Introduction";
import Section1 from "@/components/contents/section1";
import Section2 from "@/components/contents/section2";
import Section3 from "@/components/contents/section3";
import End from "@/components/contents/end";
import FootContent from "@/components/Layouts/FootContent";
import HeadNavBarMini from "@/components/Layouts/HeadNavBarMini";

export default {
  name: 'Home',
  components: {
    Warn,
    HeadNavBarMini,
    FootContent,
    End,
    Section3,
    Section2,
    Section1,
    Introduction,
    HeadNavBar,
  },
  data() {
    return {
      home: home,
    }
  }
}
</script>
<style lang="less">

</style>
